import { LocaleName } from "@/app/i18n/settings";

export const manualLink = {
  de: "https://storage.googleapis.com/images-matchbus-192820/intern/Handbuch_2026-10-14_DE.pdf",
  en: "https://storage.googleapis.com/images-matchbus-192820/intern/Handbuch_EN_081225.pdf",
  es: "https://storage.googleapis.com/images-matchbus-192820/intern/Handbuch_ES_081225.pdf",
};

export const flyerLink = {
  de: "https://images-matchbus-192820.storage.googleapis.com/intern/flyer.pdf",
  en: "https://images-matchbus-192820.storage.googleapis.com/intern/english-flyer.pdf",
  es: "https://images-matchbus-192820.storage.googleapis.com/intern/english-flyer.pdf",
};

export function getLocalizedRoute<T extends string>(
  lng: LocaleName,
  route: T,
): `/${LocaleName}/${T}` {
  return `/${lng}/${route}`;
}
